import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetLargeClaimDetails,
  AddLargeClaim,
  DeleteLargeClaim,
  UpdateLargeClaim,
} from "../../../../api/User/ACG/LargeClaimApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import { companySize } from "../../../../Utils/constants";
import CustomInputField from "../../../../components/common/CustomInputField";
import { GetIndrDetails } from "../../../../api/User/ACG/IndrApi";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  industry: Yup.string()
    .notOneOf(["Select Industry"], "Please select industry")
    .required("Please select industry"),
  company_Size: Yup.string()
    .notOneOf(["Select Company Size"], "Please select company size")
    .required("Please select company size"),
  assessment: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter IRMI large claim factor"),
});

const LargeClaim = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [industry, setIndustry] = useState([]);
  const buttonRef = useRef(null);
  const column = [
    {
      title: "Industry",
      field: "industry",
    },
    {
      title: "Company Size",
      field: "company_Size",
    },
    {
      title: "IRMI Large Claim Factor",
      field: "assessment",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getLargeClaimDetailsData();
      GetIndrDetails().then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIndustry(res.data);
        }
      });
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getLargeClaimDetailsData();
    GetIndrDetails().then((res) => {
      if (res.status === 200 || res.status === 204) {
        setIndustry(res.data);
      }
    });
  }, []);

  const getLargeClaimDetailsData = () => {
    setIsLoading(true);
    GetLargeClaimDetails()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { industry, company_Size, assessment } = values;
    const payload = {
      id: 0,
      industry,
      company_Size,
      assessment: +assessment,
    };

    if (witchAction === "add") {
      AddLargeClaim(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateLargeClaim(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Large Claim(s)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteLargeClaim(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                industry: selectedRowData?.industry ?? "Select Industry",
                company_Size:
                  selectedRowData?.company_Size ?? "Select Company Size",
                assessment: selectedRowData?.assessment,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Industry
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0"
                            style={Fontstyling.label}
                            name="industry"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={errors.industry && touched.industry}
                          >
                            <option value="Select Industry">
                              Select Industry
                            </option>
                            {industry.map(({ industry: item }) => (
                              <option
                                value={item}
                                selected={values.industry === item}
                              >
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.industry}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Company Size
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0"
                            style={Fontstyling.label}
                            name="company_Size"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.company_Size && touched.company_Size
                            }
                          >
                            {companySize.map((item) => (
                              <option
                                value={item}
                                selected={values.company_Size === item}
                              >
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.company_Size}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <CustomInputField
                          label="IRMI Large Claim Factor"
                          name="assessment"
                          maxLength={10}
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Large Claim(s)
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default LargeClaim;
